import { LOCALISATION_CONFIG } from "@/shared/config/localisation";

export const EXPERIENCE_OPTIONS = ["0", "1", "2", "3", "4", "5", "5+"].map((value) => ({
  label: value,
  value,
}));

export const CAR_QUOTE_STEP_KEYS = {
  PERSONAL_DETAILS: "personalDetails",
  VEHICLE_DETAILS: "vehicleDetails",
  DRIVER_DETAILS: "driverDetails",
  QUOTE_SELECTION: "quoteSelection",
  DOCUMENT_UPLOAD: "documentUpload",
  ADDITIONAL_INFO: "additionalInfo",
  PAYMENT: "payment",
} as const;

export type CarQuoteStepKey = (typeof CAR_QUOTE_STEP_KEYS)[keyof typeof CAR_QUOTE_STEP_KEYS];

export const currentInsurerOptions = [
  { label: "Aman", value: "Aman" },
  { label: "GIG Gulf", value: "GIG Gulf" },
  { label: "DNIRC", value: "DNIRC" },
  { label: "SUKOON", value: "SUKOON" },
  { label: "RAK Insurance", value: "RAK Insurance" },
  { label: "Liva", value: "Liva" },
  { label: "Salama", value: "Salama" },
];

export const currentPolicyTypeOptions = [
  { label: "Comprehensive", value: "Comprehensive" },
  { label: "Third Party", value: "Third Party" },
];

export const defaultMotorCurrentInsurerOptions = [
  {
    label: "Sukoon Insurance (Formerly known as Oman Insurance Company)",
    value: "Sukoon Insurance (Formerly known as Oman Insurance Company)",
  },
  {
    label: "GIG Gulf (Formerly known as AXA Gulf)",
    value: "GIG Gulf (Formerly known as AXA Gulf)",
  },
  {
    label: "Orient Insurance PJSC",
    value: "Orient Insurance PJSC",
  },
  {
    label: "Abu Dhabi National Insurance Company (ADNIC)",
    value: "Abu Dhabi National Insurance Company (ADNIC)",
  },
  {
    label: "Dubai Insurance Co.",
    value: "Dubai Insurance Co.",
  },
  {
    label: "Dubai National Insurance & Reinsurance (DNI)",
    value: "Dubai National Insurance & Reinsurance (DNI)",
  },
  {
    label: "Al Wathba National Insurance Company (AWNIC)",
    value: "Al Wathba National Insurance Company (AWNIC)",
  },
  {
    label: "Al Buhaira National Insurance Company",
    value: "Al Buhaira National Insurance Company",
  },
  {
    label: "Al Fujairah National Insurance Company (AFNIC)",
    value: "Al Fujairah National Insurance Company (AFNIC)",
  },
  {
    label: "SALAMA (Islamic Arab Insurance Co.)",
    value: "SALAMA (Islamic Arab Insurance Co.)",
  },
];

export const gccSpecOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const newCarOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const registeredUnderOptions = [
  { label: "Individual", value: "Individual" },
  { label: "Company", value: "Company" },
];

type LocationOption = { label: string; value: string };

export const uaeEmirates: LocationOption[] = [
  { label: "Abu Dhabi", value: "abu_dhabi" },
  { label: "Dubai", value: "dubai" },
  { label: "Sharjah", value: "sharjah" },
  { label: "Ajman", value: "ajman" },
  { label: "Umm Al Quwain", value: "umm_al_quwain" },
  { label: "Ras Al Khaimah", value: "ras_al_khaimah" },
  { label: "Fujairah", value: "fujairah" },
];

export const indiaStates: LocationOption[] = [
  { label: "Andhra Pradesh", value: "andhra_pradesh" },
  { label: "Arunachal Pradesh", value: "arunachal_pradesh" },
  { label: "Assam", value: "assam" },
  { label: "Bihar", value: "bihar" },
  { label: "Chhattisgarh", value: "chhattisgarh" },
  { label: "Delhi", value: "delhi" },
  { label: "Goa", value: "goa" },
  { label: "Gujarat", value: "gujarat" },
  { label: "Haryana", value: "haryana" },
  { label: "Himachal Pradesh", value: "himachal_pradesh" },
  { label: "Jharkhand", value: "jharkhand" },
  { label: "Karnataka", value: "karnataka" },
  { label: "Kerala", value: "kerala" },
  { label: "Madhya Pradesh", value: "madhya_pradesh" },
  { label: "Maharashtra", value: "maharashtra" },
  { label: "Manipur", value: "manipur" },
  { label: "Meghalaya", value: "meghalaya" },
  { label: "Mizoram", value: "mizoram" },
  { label: "Nagaland", value: "nagaland" },
  { label: "Odisha", value: "odisha" },
  { label: "Punjab", value: "punjab" },
  { label: "Rajasthan", value: "rajasthan" },
  { label: "Sikkim", value: "sikkim" },
  { label: "Tamil Nadu", value: "tamil_nadu" },
  { label: "Telangana", value: "telangana" },
  { label: "Tripura", value: "tripura" },
  { label: "Uttar Pradesh", value: "uttar_pradesh" },
  { label: "Uttarakhand", value: "uttarakhand" },
  { label: "West Bengal", value: "west_bengal" },
  { label: "Andaman and Nicobar Islands", value: "andaman_and_nicobar_islands" },
  { label: "Chandigarh", value: "chandigarh" },
  { label: "Dadra and Nagar Haveli and Daman and Diu", value: "dadra_nagar_haveli_daman_diu" },
  { label: "Jammu and Kashmir", value: "jammu_and_kashmir" },
  { label: "Ladakh", value: "ladakh" },
  { label: "Lakshadweep", value: "lakshadweep" },
  { label: "Puducherry", value: "puducherry" },
];

export const regionOptionsByCountry: Record<string, LocationOption[]> = {
  UAE: uaeEmirates,
  IND: indiaStates,
};

const localizedCountry = String(LOCALISATION_CONFIG.country || "")
  .trim()
  .toUpperCase();

export const emirates = regionOptionsByCountry[localizedCountry] ?? uaeEmirates;
